import { create } from "zustand";

export interface State {
  resendCoolDown: number;
  setResendCoolDown: (resendCoolDown: number) => void;
}

export const useCommonStore = create<State>((set) => ({
  resendCoolDown: 0,
  setResendCoolDown: (resendCoolDown: number) => set({ resendCoolDown }),
}));
